import type { Roster } from '../characters/types';
import { maxSpellPoints } from './spellCosts';
import type { FactionId, Piece, PieceId } from './types';

/**
 * A piece as it enters play: unhurt, free of every affliction, and carrying its character's full
 * magic. Built here rather than written out wherever a piece is needed, so that a field added to
 * `Piece` reaches the board, the spells, the balance harness and the AI's what-if states at once
 * instead of being forgotten in one of them.
 */
export function newPiece(
  roster: Roster,
  id: PieceId,
  faction: FactionId,
  character: string,
  x: number,
  y: number,
): Piece {
  return {
    id,
    faction,
    character,
    x,
    y,
    damage: 0,
    imprisoned: false,
    spellPoints: maxSpellPoints(roster[character]),
    frozen: 0,
    cursed: 0,
  };
}
